export const environment = {
  production: false,
  //baseUrl: 'http://api-oficinavirtualaportantes.siris.test/api',
  baseUrl: 'http://api-oficinavirtualaportantes.mallamaseps.com/api',
  //baseUrl: 'http://localhost:5008/api',
  apiVersion: 'v1',
  appName: 'Oficina Virtual Aportantes - Desarrollo',
  version: '1.0.0'
};